module.exports = __webpack_public_path__ + "img/haukkala_talvella.175184c0.jpeg";